import type { SVGProps } from "react";
export function PlusIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      data-slot="icon"
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="currentColor">
        <rect height={1.2} rx={0.6} width={10} x={3} y={7.4} />
        <rect
          height={1.2}
          rx={0.6}
          transform="matrix(0 -1 1 0 -5.60001 20.39999)"
          width={10}
          x={7.39999}
          y={13}
        />
      </g>
    </svg>
  );
}
